<template>
  <div>
    <div class="mass-edit-wrapper">
      <switch-checkbox
        :text="$t('common.mass-edit')"
        :onChange="toggleMassEdit"
        :checked="isMassEdit"
      />
    </div>

    <list-widget
      :items="permits.items"
      routeName="permit"
      :hideHeader="true"
      :changeRoute="true"
      :addNewTitle="$t('add_permit.new_permit')"
      addNewRouteName="add-permit"
      :doNotRouteOnRouteNames="['add-permit-to-user']"
    >
      <template slot="item-template" slot-scope="props">
        <ListItemTemplate
          :item="props.item"
          :isMassEdit="isMassEdit"
          :onClickCheckbox="addToCheckedList"
          :checked="isFindOnCheckedList(props.item.id)"
        ></ListItemTemplate>
      </template>
    </list-widget>
    <div class="list-widget__footer items-container__footer" v-if="permits.items">
      <slot name="footer">
        <a
          class="link"
          v-on:click.stop.prevent="extendLimit()"
          v-if="permits.total > permits.items.length"
        >{{ $t('common.load_more') }}</a>

        <div class="footer-actions" v-if="checkedList.length">
          <div class="footer-actions__selected">{{ $t('common.selected') }}: {{checkedList.length}}</div>
          <div class="footer-actions__actions">
            {{ $t('common.actions') }}:
            <button
              type="button"
              class="btn btn--main btn--small"
              @click="showDeletingModal"
            >{{ $t('common.delete') }}</button>
            <button
              type="button"
              class="btn btn--small"
              @click="toggleMassEdit(false)"
            >{{ $t('common.discard') }}</button>
          </div>
        </div>
      </slot>
    </div>

    <ConfirmationModal
      v-if="showDeleteConfirmationModal"
      @cancel="hideDeletingModal"
      @confirmed="bulkDelete"
    >
      <h1 slot="header">{{ $t('common.deleting') }}: {{ checkedList.length }}</h1>
      <p slot="body">{{ $t('permits.confirm_delete') }}</p>
    </ConfirmationModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListWidget from 'common/ListWidget';
import * as mTypes from 'store/mutation-types';
import ListItemTemplate from 'permits/ListItemTemplate';
import SwitchCheckbox from 'common/SwitchCheckbox';
import ConfirmationModal from 'common/ConfirmationModal';

export default {
  components: {
    ListWidget,
    ListItemTemplate,
    SwitchCheckbox,
    ConfirmationModal,
  },
  computed: mapGetters({
    permits: 'landlord/permits/permits',
    permitsLimit: 'landlord/permits/limit',
    user: 'user/user/user',
  }),
  created() {
    this.$store.commit(`landlord/permits/${mTypes.SET_LIMIT}`, 10);
    this.fetchPermits();
  },
  destroyed() {
    this.$store.commit(`landlord/permits/${mTypes.CLEAR_STATE}`);
  },
  methods: {
    fetchPermits() {
      this.$store.dispatch('landlord/permits/fetch', { keyword: this.$route.query.keyword, user: this.user }).then(() => {
        if (this.permits.total === 0) {
          this.$router.push({ name: 'add-permit' });
        }
      });
    },
    extendLimit() {
      this.$store.commit(`landlord/permits/${mTypes.SET_LIMIT}`, this.permitsLimit + 10);
      this.fetchPermits();
    },
    toggleMassEdit(isChecked) {
      this.isMassEdit = isChecked;

      if (!isChecked) {
        this.clearCheckedList();
      }
    },
    clearCheckedList() {
      this.checkedList = [];
    },
    addToCheckedList(id, isChecked) {
      if (isChecked) {
        const findItem = this.checkedList.find(item => item === id);

        if (!findItem) {
          this.checkedList = [
            ...this.checkedList,
            id,
          ];
        }
      } else {
        this.checkedList = this.checkedList.filter(item => item !== id);
      }
    },
    isFindOnCheckedList(id) {
      const findItem = this.checkedList.find(item => item === id);

      if (findItem) return true;

      return false;
    },
    showDeletingModal() {
      this.showDeleteConfirmationModal = true;
    },
    hideDeletingModal() {
      this.showDeleteConfirmationModal = false;
    },
    bulkDelete() {
      const checkedList = [...this.checkedList];
      this.hideDeletingModal();
      this.toggleMassEdit(false);

      this.$store.dispatch('permits/permit/deleteBulk', { user: this.user, ids: checkedList })
        .then(() => {
          this.$store.commit(`landlord/permits/${mTypes.REMOVE_DATAS}`, checkedList);
          this.$router.push({ name: 'permits' });
        });
    },
  },
  data() {
    return {
      isMassEdit: false,
      checkedList: [],
      showDeleteConfirmationModal: false,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/permits/Sidebar.vue